import ReportingTicketList from "./list";


if (document.body.getAttribute("data-current-path") === "reporting/ticket") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ReportingTicketList();
    }
}